import { useEffect, useState } from 'react';
import { RootState } from '../../modules';
import { useDispatch, useSelector } from 'react-redux';
import {
  VendorType,
  deleteVendorEvaluationAsync,
  getVendorDetailAsync,
} from '../../modules/vendors';
import { Col, Drawer, Row, Tabs } from 'antd';
import TabPane from 'antd/lib/tabs/TabPane';

import VendorEditDrawer from './VendorEditDrawer';
import VendorCompanyDetailComponent from '../../components/vendors/VendorCompanyDetailComponent';
import VendorWorkerDetailComponent from '../../components/vendors/VendorWorkerDetailComponent';
import { getVendorFileAPIPath } from '../../util/utils';
import { downloadFile } from '../../api/constlink';
import Title from 'antd/lib/typography/Title';
import VendorPerformanceComponent from '../../components/vendors/VendorPerformanceComponent';
import VendorEvaluationListComponent from '../../components/vendors/VendorEvaluationListComponent';
import VendorEvaluationCreateDrawer from './VendorEvaluationCreateDrawer';

export interface VendorDetailDrawerProps {
  config: any;
  visible: boolean;
  onClose: () => void;
}

function VendorDetailDrawer({
  config,
  visible,
  onClose,
}: VendorDetailDrawerProps) {
  const vendor = useSelector((state: RootState) => state.vendors.vendor.data);
  const currentUser = useSelector((state: RootState) => state.auth.auth.data);
  const [visibleEditlDrawer, setVisibleEditDrawer] = useState<boolean>(false);
  const [editDrawerConfig, setEditDrawerConfig] = useState<any>();
  const [
    visibleCreateVendorEvaluationDrawer,
    setVisibleCreateVendorEvaluationDrawer,
  ] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      getVendorDetailAsync.request({
        enterpriseId: config.enterpriseId,
        vendorId: config.vendorId,
      }),
    );
  }, [dispatch, config]);

  const moveToEditPage = () => {
    setEditDrawerConfig({ ...config });
    setVisibleEditDrawer(true);
  };

  const onCloseEditDrawer = () => {
    setVisibleEditDrawer(false);
  };

  const openCreateVendorEvaluationModal = () => {
    setVisibleCreateVendorEvaluationDrawer(true);
  };

  const onDeleteVendorEvaluation = (vendorEvaluationId: string) => {
    dispatch(
      deleteVendorEvaluationAsync.request({
        enterpriseId: config.enterpriseId,
        vendorId: config.vendorId,
        vendorEvaluationId,
      }),
    );
  };

  return (
    <>
      {vendor && (
        <Drawer
          width={1000}
          placement="right"
          closable={false}
          onClose={onClose}
          open={visible}
        >
          <Row>
            <Col>
              <Title level={4}>{vendor.application.general.name}</Title>
            </Col>
          </Row>

          <Tabs destroyInactiveTabPane>
            <TabPane tab="개요" key="1">
              {visible && vendor.type === VendorType.COMPANY && (
                <VendorCompanyDetailComponent
                  vendor={vendor}
                  moveToEditPage={moveToEditPage}
                  downloadFile={async (
                    attachFileId: string,
                    fileName: string,
                  ) => {
                    await downloadFile(
                      getVendorFileAPIPath(config.enterpriseId),
                      attachFileId,
                      fileName,
                    );
                  }}
                />
              )}
              {visible && vendor.type === VendorType.WORKER && (
                <VendorWorkerDetailComponent
                  vendor={vendor}
                  moveToEditPage={moveToEditPage}
                  downloadFile={async (
                    attachFileId: string,
                    fileName: string,
                  ) => {
                    await downloadFile(
                      getVendorFileAPIPath(config.enterpriseId),
                      attachFileId,
                      fileName,
                    );
                  }}
                />
              )}
            </TabPane>
            <TabPane tab="실적" key="2">
              <VendorPerformanceComponent vendor={vendor} />
            </TabPane>
            <TabPane tab="평가" key="3">
              {currentUser && (
                <VendorEvaluationListComponent
                  vendor={vendor}
                  currentUser={currentUser}
                  openCreateVendorEvaluationModal={
                    openCreateVendorEvaluationModal
                  }
                  onDelete={onDeleteVendorEvaluation}
                />
              )}
            </TabPane>
          </Tabs>
        </Drawer>
      )}
      {vendor && editDrawerConfig && (
        <VendorEditDrawer
          config={editDrawerConfig}
          vendor={vendor}
          visible={visibleEditlDrawer}
          onClose={onCloseEditDrawer}
        />
      )}
      {vendor && config && (
        <VendorEvaluationCreateDrawer
          visible={visibleCreateVendorEvaluationDrawer}
          config={config}
          onClose={() => setVisibleCreateVendorEvaluationDrawer(false)}
        />
      )}
    </>
  );
}

export default VendorDetailDrawer;
